import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import React, { FC, useEffect } from 'react'
import { getQueryParam } from '../../utils/getQueryParam'

const BUTTON_HREF = 'app.outdatedLink.button.href'

export const OutdatedLink: FC = () => {
  const t = useTranslations()
  const { query } = useRouter()
  const redirectUrl = getQueryParam(query, 'redirecturl')

  const loginButtonHref = `${t(BUTTON_HREF)}?`

  useEffect(() => {
    window.location.href = redirectUrl && redirectUrl !== '' ? redirectUrl : loginButtonHref
  }, [loginButtonHref, redirectUrl])

  return <></>
}

OutdatedLink.displayName = 'OutdatedLink'
